import { NextOptimizedImage } from './src'

export default NextOptimizedImage
